import { render } from "./MyTechnology.vue?vue&type=template&id=b8f3b0dc&scoped=true&bindings={}"
import script from "./MyTechnology.vue?vue&type=script&lang=ts"
export * from "./MyTechnology.vue?vue&type=script&lang=ts"

import "./MyTechnology.vue?vue&type=style&index=0&id=b8f3b0dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b8f3b0dc"

export default script